import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="pile">
      <h1>Page inconnue</h1>
      <p className="doux">Cette adresse ne correspond à aucun écran de DiagFlow.</p>
      <p>
        <Link to="/postes">Retour à la liste des postes</Link>
      </p>
    </div>
  );
}
